<app-page [kontentCodename]="'recommended_curriculum__page_'"></app-page>
